import { environment } from '../../../environments/environment';

// Browser-side diagnostics are intentionally limited to the staging bundle.
// Never include Supabase tokens, user IDs, query payloads or response bodies.
const enabled = environment.name === 'staging';

export function stagingTrace(
  area: string,
  event: string,
  details: Record<string, unknown> = {}
): void {
  if (!enabled) return;
  console.info(`[STAGING][${area}] ${event}`, {
    at: new Date().toISOString(),
    ...details
  });
}

export function stagingTraceError(
  area: string,
  event: string,
  error: unknown,
  details: Record<string, unknown> = {}
): void {
  if (!enabled) return;
  const issue = error && typeof error === 'object'
    ? error as Record<string, unknown>
    : {};
  const rawMessage = issue['message'];

  console.warn(`[STAGING][${area}] ${event}`, {
    at: new Date().toISOString(),
    ...details,
    errorName: error instanceof Error ? error.name : typeof error,
    errorCode: typeof issue['code'] === 'string' ? issue['code'] : null,
    errorStatus: typeof issue['status'] === 'number' ? issue['status'] : null,
    errorMessage: typeof rawMessage === 'string' ? rawMessage.slice(0, 240) : null
  });
}
